"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.query = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.query = (0, graphql_tag_1.default) `
  query FanProModulateQuery($inputs: [FanProInputType!]!) {
    user {
      fanProModulate(input: $inputs) {
        errors {
          code
          text
        }
        warnings {
          code
          text
        }
        fanShaftMechanicalEfficiency
        fanShaftStaticEfficiency
        fanMechanicalEfficiency
        fanStaticEfficiency        
        fanSpeed
        maxFanSpeed
        staticPressure
        totalPressure
        velocityPressure
        systemEffectPressureDrop
        gridPower
        shaftPower
        outletVelocity
        motorSpeed
        maxMotorSpeed
        motorFrequency
        maxMotorFrequency
        current
        cosPhi
      }
    }
  }
`;
//# sourceMappingURL=queries.js.map